// extracted by mini-css-extract-plugin
module.exports = {"site-alerts":"_site_alerts_site-alerts__1N3Z6"};